//Ropsten
export const ETHMiAddress = "0x9f35d0d0a2c46293Adad9D16fD847445b100EFB8"
export const ETHKeyAddress = "0x43f07f1D52EB52CCCA4601baC8b9d034465a3899"
export const TreasuryAddress = "0xc927768424CF6425df7f58Fd31895d4D0f6eb9af"

export const ETHMIEtherscan = "https://etherscan.io/address/0x9f35d0d0a2c46293adad9d16fd847445b100efb8"
export const ETHKeyEtherscan = "https://etherscan.io/address/0x43f07f1d52eb52ccca4601bac8b9d034465a3899"
export const TreasuryEtherscan = "https://etherscan.io/address/0xc927768424cf6425df7f58fd31895d4d0f6eb9af"

export const Github = "https://github.com/MaikuroFinance/ETHMicro"
export const Docs = "https://docs.ethmicro.com"
